import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { openConfirmModal } from "../../../components/modals/ConfirmModal";
import { NewMoneyStatuses, useAdminNewMoney } from "../hooks/useAdminNewMoney";
import { NewMoneyEditModal } from "./NewMoneyEditModal";

const NewMoneyActionToggle = React.forwardRef(({ onClick }, ref) => (
    <FontAwesomeIcon
        ref={ref}
        className="has-pointer"
        icon="fa-ellipsis"
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    />
));

export const NewMoneyEditCellComponent = ({ row }) => {
    const { newMoneyId, status } = row;

    const {
        approveNewMoney, cancelNewMoney, saveNewMoney, canWrite, isLoading, isSaving
    } = useAdminNewMoney();

    const [showEditModal, setShowEditModal] = useState(false);

    const save = (newMoney, overwriteComment) => saveNewMoney(newMoneyId, newMoney, overwriteComment);

    const showConfirmChangeStatus = (newStatus) => {
        const isApproving = newStatus === NewMoneyStatuses.Approved;
        openConfirmModal({
            message: <>
                Are you sure you want to <strong>{isApproving ? "approve" : "abort"}</strong> this new money?
            </>,
            confirmButtonVariant: isApproving ? "success" : "danger",
        }).then(
            (proceed) => {
                if (proceed) {
                    if (isApproving)
                        approveNewMoney(newMoneyId);
                    else
                        cancelNewMoney(newMoneyId);
                }
            }
        );
    }

    return <td className={classNames("text-center align-middle", { "d-none": !canWrite })}>
        <NewMoneyEditModal
            show={showEditModal}
            onHide={() => setShowEditModal(false)}
            save={save}
            isSaving={isSaving}
            existingNewMoney={row}
            disabled={isLoading}
        />
        {/* Show dropdown with status change ability if pending, otherwise edit button */}
        {status === NewMoneyStatuses.Pending
            ? <Dropdown className="caret-off w-100">
                <Dropdown.Toggle as={NewMoneyActionToggle} />
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => setShowEditModal(true)}>
                        Edit New Money
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={() => showConfirmChangeStatus(NewMoneyStatuses.Approved)}>Approve New Money</Dropdown.Item>
                    <Dropdown.Item onClick={() => showConfirmChangeStatus(NewMoneyStatuses.Aborted)}>Mark as Not Taken Up</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
            : <FontAwesomeIcon
                onClick={() => setShowEditModal(true)}
                icon="pen-to-square"
                className="has-pointer"
                size="lg" />}
    </td>;
};